import type React from "react";
import {ActionBarButton} from "./ActionBarButton.js";

interface ActionBarProps {
  children:
    | React.ReactElement<typeof ActionBarButton>
    | (React.ReactElement<typeof ActionBarButton> | false)[];
}

function ActionBarComponent({children}: ActionBarProps) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: "8px",
        backgroundColor: "rgba(var(--mt-color-action-rgb), 0.16)",
        borderRadius: "14px",
      }}
    >
      {children}
    </div>
  );
}

export const ActionBar = Object.assign(ActionBarComponent, {
  Button: ActionBarButton,
});
